<template>
  <v-card>
    <v-form>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field :value="bus" disabled label="事業本部"/>
          </v-flex>
          <v-flex xs6>
            <v-text-field :value="departments" disabled label="事業部"/>
          </v-flex>
          <v-flex xs3>
            <v-text-field :value="invoiceAmount" disabled label="INV 外貨額"/>
          </v-flex>
          <v-flex xs3>
            <v-text-field :value="shipment.finallyWarehouseName" disabled label="納入場所"/>
          </v-flex>
          <v-flex xs3>
            <v-text-field :value="containerQty" disabled label="コンテナ本数"/>
          </v-flex>
          <v-flex xs3>
            <v-text-field :value="shipment.forecastDeliveryDate" disabled label="納入予定日付"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
export default {
  props: ['shipment'],
  data() {
    return {}
  },
  computed: {
    containerQty() {
      return (
        this.shipment &&
        this.shipment.packages &&
        [...new Set(this.shipment.packages.map(p => p.containerNo))].length
      )
    },
    invoiceAmount() {
      return (
        this.shipment &&
        this.shipment.packages &&
        this.shipment.packages.reduce((t, p) => {
          return t + p.jpytotal
        }, 0)
      )
    },
    bus() {
      return (
        this.shipment &&
        this.shipment.packages &&
        [
          ...new Set(this.shipment.packages.map(p => p.buHeadquartersName))
        ].join(', ')
      )
    },
    departments() {
      return (
        this.shipment &&
        this.shipment.packages &&
        [...new Set(this.shipment.packages.map(p => p.departmentName))].join(
          ', '
        )
      )
    }
  }
}
</script>